import { createZustandStore } from "@bounce/state-management"
import type { BasicObject } from "@bounce/util"

import type { Variant } from "../types"

type UseVariantsStore = {
  variants: BasicObject<Variant>
  setVariant: (key: string, variant: Variant) => void
  clear: () => void
}

export const useVariants = createZustandStore<UseVariantsStore>({
  name: "useVariants",
  initializer: setState => ({
    variants: {},
    setVariant: (key, variant) => setState(({ variants }) => ({ variants: { ...variants, [key]: variant } })),
    clear: () => {
      setState({ variants: {} })
    },
  }),
})

export const setVariants = (variants: UseVariantsStore["variants"]) => {
  useVariants.setState(state => ({ variants: { ...state.variants, ...variants } }))
}
